export default "__VITE_ASSET__BzuTUomj__"